import React from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import Button from '@material-ui/core/Button';

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  button: {
    minWidth: 175,
    fontSize: '1.2em',
  },
}));

export default function NextButton({
  isFinalStep = false,
  isPrimary = true,
  onClick,
}: {
  isFinalStep?: boolean;
  isPrimary?: boolean;
  onClick: (...args) => any;
}) {
  const classes = useStyles({ isFinalStep });

  return (
    <div className={classes.root}>
      <Button
        variant={isPrimary ? 'contained' : 'text'}
        color={isPrimary ? 'primary' : 'default'}
        className={`${classes.button} `}
        onClick={onClick}
        data-automation-id="nextOrSubmit"
      >
        {isFinalStep ? 'Submit Application' : 'Next'}
      </Button>
    </div>
  );
}
